import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/adminlock128.png'


const _withScopeId = n => (_pushScopeId("data-v-0c3e9be4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "admin" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Welcome to the secret page", -1))
const _hoisted_3 = { class: "row mx-0 px-0" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6 text-container" }, [
  /*#__PURE__*/_createElementVNode("p", null, " This is a secret page for admin stuff. If you have the credentials, then go right ahead. If you do not have credentials, then this page isn't very useful for you. "),
  /*#__PURE__*/_createElementVNode("div", { class: "image-container" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "image",
      src: _imports_0,
      alt: "Image of a lock"
    }),
    /*#__PURE__*/_createElementVNode("p", { class: "image-caption" }, "I sure hope this system is secure.")
  ])
], -1))
const _hoisted_5 = { class: "col-sm-6 px-0 login-container d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageHeader = _resolveComponent("PageHeader")!
  const _component_LoginForm = _resolveComponent("LoginForm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PageHeader),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_LoginForm)
        ])
      ])
    ])
  ], 64))
}